import type { AppRouteModule } from '/@/router/types'

import { LAYOUT } from '/@/router/constant'
import { t } from '/@/hooks/web/useI18n'

const system: AppRouteModule = {
    path: '/system',
    name: 'System',
    component: LAYOUT,
    redirect: '/system/menu',
    meta: {
        orderNo: 2000,
        icon: 'ion:settings-outline',
        title: t('routes.demo.system.moduleName'),
    },
    children: [
        {
            path: 'menu',
            name: 'MenuManagement',
            meta: {
                title: t('routes.demo.system.menu'),
                icon: 'carbon:menu',
                ignoreKeepAlive: true,
            },
            component: () => import('/@/views/demo/system/menu/index.vue'),
        },
        {
            path: 'role',
            name: 'RoleManagement',
            meta: {
                title: t('routes.demo.system.role'),
                icon: 'carbon:user-role',
                ignoreKeepAlive: true,
            },
            component: () => import('/@/views/demo/system/role/index.vue'),
        },
        {
            path: 'dept',
            name: 'DeptManagement',
            meta: {
                title: t('routes.demo.system.dept'),
                icon: 'mingcute:department-line',
                ignoreKeepAlive: true,
            },
            component: () => import('/@/views/demo/system/dept/index.vue'),
        },
        {
            path: 'post',
            name: 'PostManagement',
            meta: {
                title: t('routes.demo.system.post'),
                icon: 'mdi:account-tie',
                ignoreKeepAlive: true,
            },
            component: () => import('/@/views/demo/system/post/index.vue'),
        },
        {
            path: 'account',
            name: 'AccountManagement',
            meta: {
                title: t('routes.demo.system.account'),
                icon: 'mdi:user',
                ignoreKeepAlive: false,
            },
            component: () => import('/@/views/demo/system/account/index.vue'),
        },
        {
            path: 'dict',
            name: 'DictManagement',
            meta: {
                title: t('routes.demo.system.dict'),
                icon: 'mdi:dictionary',
                ignoreKeepAlive: false,
            },
            component: () => import('/@/views/demo/system/dict/index.vue'),
        },
        {
            path: 'category',
            name: 'CategoryManagement',
            meta: {
                title: t('routes.demo.system.category'),
                icon: 'material-symbols:category-outline',
                ignoreKeepAlive: false,
            },
            component: () => import('/@/views/demo/system/category/index.vue'),
        },
        {
            path: 'region',
            name: 'RegionManagement',
            meta: {
                title: t('routes.demo.system.region'),
                icon: 'majesticons:map-marker-area-line',
                ignoreKeepAlive: false,
            },
            component: () => import('/@/views/demo/system/region/index.vue'),
        },
    ],
}

export default system
